export interface Scripts {
  name: string;
  src: string;
}

export const Scripts: Scripts[] = [

  { name: 'icarSDK', src: '../../assets/js/icarSDK_v1-6-9_b1138.js?v=165' },
  { name: 'mitekSDK', src: '../../assets/js/mitek-science-sdk.js' }
];
export enum StateIcar {
  OK                      = 0,
  NO_CAMERA_DEVICES       = 1,
  NO_CAMERA_PERMISSION    = 2,
  UNAVAILABLE_CAMERA      = 3,
  UNSUPPORTED_BROWSER     = 4,
  UNKNOWN_ERROR           = 5,
  ENDVIDEO                = 6,
  RESULT_OK               = 7,
  RESULT_KO               = 8,
  MANUAL_TRIGER           = 9
}

export enum StateMitek {
  STARTSDK    = 0,
  STOPSDK     = 1,
  ERRORSDK    = 2,
  RESULTSDK   = 3
}

export enum captureDocs {
  DNIFRONT    = 0,
  DNIBACK     = 1,
  FACE        = 2

}
